import React from 'react';
import { StyleTemplate } from '../types/template';
import CachedImage from './CachedImage';
import './TemplateCard.css';

interface TemplateCardProps {
  template: StyleTemplate;
  onClick?: (template: StyleTemplate) => void;
}

const TemplateCard: React.FC<TemplateCardProps> = ({ template, onClick }) => {
  const handleClick = () => {
    onClick?.(template);
  };

  return (
    <div 
      className="template-card" 
      onClick={handleClick}
    >
      <div className="template-cover">
        <CachedImage 
          src={template.imageUrl} 
          alt={template.name}
          loading="lazy"
          className="template-cover-image"
        />
      </div>
      <div className="template-info">
        <h3 className="template-title">{template.name}</h3>
      </div>
      <button 
        className="make-similar-btn" 
        onClick={handleClick}
      >
        制作同款
      </button>
    </div>
  );
};

export default TemplateCard;
